// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-button[data-v-399df33d]{bottom:88px;border-radius:40px;box-shadow:0 6px 12px 0 rgba(0,0,0,.3);color:#fff}.filter-button-for-app[data-v-399df33d]{bottom:120px}.with-first-purchase-promo[data-v-399df33d]{bottom:170px}.with-logos-only[data-v-399df33d]{bottom:150px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
